import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Sparkle } from "@phosphor-icons/react";

const AISummaryStrip = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      ref={ref}
      className="py-16 md:py-20 px-6 md:px-12 lg:px-24 relative"
      data-testid="ai-summary-section"
    >
      <div className="relative z-10 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#00E5FF]/10 border border-[#00E5FF]/20 mb-6">
            <Sparkle size={16} weight="duotone" className="text-[#00E5FF]" />
            <span className="text-sm text-[#00E5FF] font-medium">The First Practical Step in Enterprise AI</span>
          </div>
          
          <p className="text-lg md:text-xl text-[#FAFAFA] font-medium leading-relaxed max-w-3xl mx-auto">
            OnTenacity helps leadership begin the AI journey with something concrete: source-backed 
            executive intelligence from the systems and context the enterprise already has.
          </p>
          
          <p className="mt-4 text-sm text-[#71717A]">
            Start with clarity. Activate the highest-value AI path first.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default AISummaryStrip;
